import { jsonPost } from '../json-request';
import type { ValidatedApiClient } from '../types/api-client';
import { VIDEO_FEED_API_PATH, videoReportApiPath } from './constants';
import { type VideoReportRequest, videoFeedResponseSchema, videoReportResponseSchema } from './schema';

export const createVideosApi = ({ validatedFetch }: ValidatedApiClient) => ({
    getFeed: (signal?: AbortSignal) =>
        validatedFetch(videoFeedResponseSchema, VIDEO_FEED_API_PATH, new URLSearchParams(), { signal }),
    report: ({ videoId, body }: { videoId: string; body: VideoReportRequest }) =>
        validatedFetch(videoReportResponseSchema, videoReportApiPath(videoId), new URLSearchParams(), jsonPost(body)),
});

export type VideosApi = ReturnType<typeof createVideosApi>;
